<script setup>

defineProps({
    titulo: {
        type: String,
    },
    descricao: {
        type: String,
    },
    total: {
        type: Number,
    },
    tituloSize: {
        type: String,
        default: 'text-3xl',
    },
});

</script>

<template>
    <div class="flex flex-column gap-1">
        <h1 :class="['text-900 m-0 font-semibold', tituloSize]">
            <slot name="titulo">{{ titulo }}</slot>
        </h1>
        <p class="text-500 m-0 text-sm">
            <slot name="descricao">{{ descricao }}</slot>
        </p>
    </div>
</template>